/* eslint-disable no-console */
import Cookies from "universal-cookie";
import {
  fetchWrapperWithoutToken,
  getNewLoginAPIPromise,
  fetchWrapperTextResponse,
} from "../APIutils";
import {
  NEW_BASE_URL,
  AUTH_TOKEN,
  LOGIN_AUTHENTICATION,
  LOGOUT_USER,
} from "../../Constant";
import { googleProperties } from "./properties";
import Config from "../../config";
import { encryptString } from "../authorization";

function getFormBodyFromJson(details) {
  let formBody = [];
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (const property in details) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(details[property]);
    formBody.push(`${encodedKey}=${encodedValue}`);
  }
  formBody = formBody.join("&");
  return formBody;
}

export function fetchAccessToken(userName, password) {
  const details = {
    username: userName,
    password,
    grant_type: "password",
  };
  const formBody = getFormBodyFromJson(details);
  const authBasicHeader = btoa(`${googleProperties.google.clientId}:${googleProperties.google.clientSecret}`);

  return fetchWrapperWithoutToken(`${Config.NEW_API.COA_BASE_URL}/${AUTH_TOKEN}`, {
    method: "post",
    headers: {
      Authorization: `Basic ${authBasicHeader}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: formBody,
  });
}

export function fetchLoggedInUser(userId) {
  const encodedValue = encodeURIComponent(userId);
  const url = `${Config.NEW_API.COA_BASE_URL}/${LOGIN_AUTHENTICATION}?userId=${encodedValue}`;
  return new Promise((resolve, reject) => {
    fetchWrapperWithoutToken(url, { method: "get" })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function logoutAuthenticateUser(userId) {
  let url = `${Config.NEW_API.COA_BASE_URL}/${LOGOUT_USER}`;
  if (userId) {
    url = `${url}?userId=${userId}`;
  }
  return fetchWrapperTextResponse(url, {
    method: "post",
  });
}

export const removeCookiesOnLogoutUser = async () => {
  const cookies = new Cookies();
  const userId = localStorage.getItem("userId");
  const currentDate = new Date();
  const expirationDate = new Date();
  expirationDate.setDate(currentDate.getDate() + 7);
  const encryptedLoginCookie = encryptString("loggedOut");
  cookies.remove(Config.cookieKeys.user, { path: "/", domain: ".chalo.com" });
  cookies.set(Config.cookieKeys.loginState, encryptedLoginCookie, {
    domain: ".chalo.com",
    expires: expirationDate,
  });
  return logoutAuthenticateUser(userId)
    .then((val) => val)
    .catch((e) => {
      console.log("error while removing cookies: ", e);
      throw e;
    });
};

export const maintainReconUser = async (params) => {
  const url = `${NEW_BASE_URL}/v1/auth/login`;
  return getNewLoginAPIPromise(url, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: {
      ...params,
    },
  });
};
